import { ControleConductivite } from "./controle-conductivite"

export class ControleConductiviteGroup {
    Code: string
    Date: Date
    SamplerPuid: string

    C1413: ControleConductivite = new ControleConductivite()
    C84: ControleConductivite = new ControleConductivite()

    static mapFromJSON(json: any): ControleConductiviteGroup {
        const ccg = new ControleConductiviteGroup();

        ccg.Code = json.code;
        ccg.Date = json.date;
        ccg.SamplerPuid = json.samplerPuid;

        if (json.c1413) {
            ccg.C1413 = ControleConductivite.mapFromJSON(json.c1413);
        }
        if (json.c84) {
            ccg.C84 = ControleConductivite.mapFromJSON(json.c84);
        }

        return ccg
    }
}